<script>
    export let currentRoute
    export let params = {}
</script>

<svelte:head>
    <title>Game Stockholder - About</title>
</svelte:head>

<div class="container">
    <div class="row">
        <div class="col-lg-5 col-sm-6">
            <div class="clearfix"></div>
            <h2 class="section-heading">Об игре</h2>
            <p class="text-justify">“Акционер” - это интеллектуальная игра со спортивным уклоном. Игра была создана
                в 1983 году киевскими любителями Александром Зыряновым и другими на основе американской игры “Брокер”.
                Впервые правила игры были опубликованы в 4-м номере журнала "Наука и жизнь" за 1990 год.
                Игра имитирует некоторые ситуации, возникающие на бирже,
                однако ее нельзя рассматривать как симулятор биржи или “Форекса”. Цель игры - получить наибольший доход от купли-продажи акций четырех цветов, влияя на их курс
                с помощью выданных карт. В игре участвуют минимум два игрока. Максимальное число игроков ограничено количеством карт. Победителем считается тот игрок, чей
                капитал превысит капиталы соперников. В игре присутствует элемент случайности, связанный с раздачей карт. Однако исход игры в значительной степени зависит от
                умения стратегически и тактически мыслить, гибко реагировать на действия соперника.
                Игра “Акционер” - это не примитивная последовательность ходов и операций купли-продажи. Это увлекательный игровой поединок интеллекта, воли и характера игроков.
                Это умение пойти на риск или, наоборот, умение удержать себя от откровенной авантюры. Это ещё и умение дружить с удачей, привлекая её на свою сторону, и умение
                не роптать на удары судьбы, понимая, что случай не всегда играет на твоей стороне.</p>
        </div>
        <div class="col-lg-5 col-lg-offset-2 col-sm-6">
            <img class="img-responsive" src="/img/aktsioner-printed-version-rounded.png" alt="">
        </div>
    </div>
</div>
